<template>
    <div class="writer-week">
        <loading-block v-if="loading" />
        <div v-else>
            <div v-if="writers.length > 0">
                <author-small
                    v-for="item in writers"
                    v-bind:key="item._id"
                    :name="item.fullname"
                    :image="'https://thumb.suara.com/avatar/user/resize/200/'+item.user_id"
                    :url="item.url"
                    :article="item.totalArticle" />
            </div>
            <div v-else class="text-center">
                <p>Tidak ada top writer</p>
            </div>
        </div>
    </div>
</template>
<style scoped>
.writer-week {
    padding: 0 0%;
}
</style>
<script>
import axios from "axios";
import AuthorSmall from "./Card/AuthorSmall";

export default {
    components: {
        AuthorSmall
    },
    data() {
        return {
            loading: true,
            writers: [],
        }
    },
    mounted() {
        this.getTopWriter()
    },
    methods: {
        getTopWriter() {
            const token = this.$cookies.get('token');
            axios.get(`/api/widget/top/writer`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.writers = response.data
                    this.loading = false
                })
                .catch((error) => {

                });
        },
    }
}
</script>
